import globals from '../../globals';
import { _sendWithAxios, _sendWithAxiosBlob } from '../api'

const REACT_APP_URL_BASE_API = globals.REACT_APP_URL_BASE_API;

//SELLER
export const empresasSeller = async (pagina) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}SellerEmpresa/empresas-seller/${pagina}/10`, 'GET')
}

export const empresasSellerTodos = async () => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}SellerEmpresa/empresas-seller`, 'GET')
}

export const empresasSellerComFiltro = async (filtro, pagina) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}SellerEmpresa/empresas-seller/${filtro}/${pagina}/10`, 'GET')
}

export const detalheEmpresaSeller = async (idEmpresa) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}SellerEmpresa/detalhes-seller/${idEmpresa}`, 'GET')
}

export const cadastrarSeller = async (data) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}SellerEmpresa/cadastrar-seller`, 'POST', data)
}

export const editarSeller = async (data) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}SellerEmpresa/atualizar-empresa-seller`, 'PUT', data)
}

export const inativarSeller = async (idEmpresa) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}SellerEmpresa/inativar-empresa-seller/${idEmpresa}`, 'PUT')
}

export const ativarSeller = async (idEmpresa) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}SellerEmpresa/ativar-empresa-seller/${idEmpresa}`, 'PUT')
}

export const gerarExelSellers = async () => {
    return await _sendWithAxiosBlob(`${REACT_APP_URL_BASE_API}SellerEmpresa/gerar-exel-sellers`, 'GET')
}

//CDS-SELLER
export const centroDistribuicaoSeller = async (pagina, idEmpresa) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}CentroDistribuicaoSeller/centro-distribuicao-seller/${idEmpresa}/${pagina}/10`, 'GET')
}

export const centroDistribuicaoSellerComFiltro = async (idEmpresa, filtro, pagina) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}CentroDistribuicaoSeller/centro-distribuicao-seller/${idEmpresa}/${filtro}/${pagina}/10`, 'GET')
}

export const detalheCentroDistribuicaoSeller = async (idCentroDistribuicao) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}CentroDistribuicaoSeller/detalhes-cd-seller/${idCentroDistribuicao}`, 'GET')
}

export const cadastrarCentroDistribuicaoSeller = async (data, idEmpresaSeller) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}CentroDistribuicaoSeller/cadastrar-cd-seller/${idEmpresaSeller}`, 'POST', data)
}

export const editarCentroDistribuicaoSeller = async (data) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}CentroDistribuicaoSeller/atualizar-cd-seller`, 'PUT', data)
}

export const inativarCentroDistribuicaoSeller = async (idCentroDistribuicao) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}CentroDistribuicaoSeller/inativar-cd-seller/${idCentroDistribuicao}`, 'PUT')
}

export const ativarCentroDistribuicaoSeller = async (idCentroDistribuicao) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}CentroDistribuicaoSeller/ativar-cd-seller/${idCentroDistribuicao}`, 'PUT')
}


export const primeiroAcessoSeller = async (data) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}PrimeiroAcesso/primeiro-acesso-seller`, 'POST', data);
}

export const resetarSenha = async (data) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}User/resetar-senha`, 'POST', data);
}

export const aceitarTermo = async (idEmpresa) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}PrimeiroAcesso/primeiro-acesso-termo-seller/${idEmpresa}`, 'GET');
}

export const gerarExelCentroDistribuicao = async (idEmpresa) => {
    return await _sendWithAxiosBlob(`${REACT_APP_URL_BASE_API}CentroDistribuicaoSeller/gerar-exel-cds/${idEmpresa}`, 'GET')
}


